export default __webpack_public_path__ + "static/media/srisailamTempleOne.74d13e3b.jpg";